exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".src-components-terrainProfile-___TerrainProfile__pathSvg___GJZgW {\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tbottom: 0;\t\n}\n\n.src-components-terrainProfile-___TerrainProfile__profileCanvas___1lPZm {\n\twidth: 100%;\n\theight: 100%;\n\tposition: absolute;\n\tbottom: 0;\n}\n\n.src-components-terrainProfile-___TerrainProfile__profileHolder___aHpcw {\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n    bottom: 0;  \n    position: relative;\n    clip-path: inset(0 0 0 0);\n    transition: all 2s ease-in-out;\n}", ""]);

// exports
exports.locals = {
	"pathSvg": "src-components-terrainProfile-___TerrainProfile__pathSvg___GJZgW",
	"profileCanvas": "src-components-terrainProfile-___TerrainProfile__profileCanvas___1lPZm",
	"profileHolder": "src-components-terrainProfile-___TerrainProfile__profileHolder___aHpcw"
};